module.exports = __webpack_public_path__ + "static/media/availability.51ca77da.svg";